<section class="main-section">
    <section class="border-0 h-100 w-100 bg-transparent">
        <div class="text-center">

            <div class="card h-100 shadow">
                <div class="card-body">

                    <h2 class="mb-3 d-none d-lg-block">{{ 'Skúšky' | translate }}</h2>

                    <app-zapisny-list-selector class="pb-0"></app-zapisny-list-selector>

                    <!-- mobilný riadok: input + tlačidlo v jednej línii -->
                    <div class="d-sm-none d-flex justify-content-between gap-2 px-2">

                        <div>
                            <mat-chip-listbox
                                aria-label="Filter"
                                (change)="filterChange($event)"
                                multiple="true"
                            >
                                <mat-chip-option class="my-mat-chip-option" value="1" i18n [selected]="kdeSaMozemPrihlasit">Môžem sa prihlásiť</mat-chip-option>
                                <mat-chip-option class="my-mat-chip-option" value="2" i18n [selected]="kdeSomPrihlaseny">Som prihlásený</mat-chip-option>
                            </mat-chip-listbox>
                        </div>

                        <button
                            [ngClass]="{'off': !showSmallFilter}"
                            (click)="switchSmallFilter()"
                            mat-mini-fab
                            aria-label="Filter">
                            <mat-icon>search</mat-icon>
                        </button>
                    </div>

                    <div [ngClass]="{'d-none': !showSmallFilter}">
                        <mat-form-field class="flex-grow-1 mt-3 mb-0">
                            <mat-label i18n>Filter</mat-label>
                            <input #searchInput matInput type="text" [(ngModel)]="search">
                            <button *ngIf="search" matSuffix mat-icon-button aria-label="Clear" (click)="search=''">
                                <mat-icon>close</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>

<!--  filter -->

                    <div class="d-none d-sm-block">
<div class="mt-2 mt-md-0 ms-3 mb-md-3 d-flex align-items-center justify-content-between align-middle p-2">

    <mat-chip-listbox
        aria-label="Filter"
        (change)="filterChange($event)"
        multiple="true"
    >
        <mat-chip-option class="my-mat-chip-option" value="1" i18n [selected]="kdeSaMozemPrihlasit">Môžem sa prihlásiť</mat-chip-option>
        <mat-chip-option class="my-mat-chip-option" value="2" i18n [selected]="kdeSomPrihlaseny">Som prihlásený</mat-chip-option>
    </mat-chip-listbox>

  <div>
    <mat-form-field>
        <mat-label i18n>Filter</mat-label>
        <input matInput type="text" [(ngModel)]="search">
        <button *ngIf="search" matSuffix mat-icon-button aria-label="Clear" (click)="search=''">
          <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>
  </div>

</div>
                    </div>

<div *ngIf="skusky.skusky">

  <div>
    <div *ngFor="let skuskyOnDate of skusky.skusky">

    <div class="card shadow-sm m-3" *ngIf="(skuskyOnDate.skusky | filterPredmetPipe: search:kdeSomPrihlaseny:kdeSaMozemPrihlasit).length > 0">
      <div class="card-body">

        <div class="row">

            <!-- den a datum -->
            <div class="col-lg-2 text-nowrap black">{{skuskyOnDate.datum}}</div>

          <div class="col">

            <div *ngFor="let skuska of skuskyOnDate.skusky | filterPredmetPipe: search:kdeSomPrihlaseny:kdeSaMozemPrihlasit; let last = last"
               [ngClass]="{'mb-5': !last, 'past': !mozeSaPrihlasit(skuska)}"
               class="row">

              <div class="col-12 col-md text-md-start" [ngClass]="{'font-italic': !skuska.faza}">

                <div *ngIf="skuska.bude" id="target"> </div>

                <span class="badge badge-secondary">{{skuska.cas}}</span>
                <span class="fw-bold ms-2 black">{{skuska.predmetSkratka}} - {{skuska.predmetNazov}}</span>
                  @if (skuska.terminNaplneny) {
                      &nbsp;<span class="small" i18n>(obsadený termín)</span>
                  }
                <div class="small" *ngIf="skuska.datumPrihlasDoSk">
                  <span i18n>prihlasovanie do</span>: {{skuska.datumPrihlasDoSk}}
                </div>
                <div *ngIf="skuska.faza" class="small font-italic">{{skuska.faza}}</div>

                  <!-- hodnotenie terminu -->
                  <div class="d-block d-md-none fw-bold black" *ngIf="skuska.hodnotenieTermin as h">
                      {{ h }}
                      <ng-container *ngIf="getPopis(h) as p">
                          <span *ngIf="p"> - {{ p }}</span>
                      </ng-container>
                  </div>

                  <!-- hodnotenie predmetu -->
                  <ng-container *ngIf="!skuska.hodnotenieTermin">
                      <div class="fw-bold black" *ngIf="skuska.hodnoteniePredmet as h">
                          <ng-container *ngIf="!skuska.mozeSaPrihlasit">
                              <span i18n>Hodnotenie z predmetu je už uzavreté</span>
                          </ng-container>
                      </div>
                  </ng-container>

              </div>

                <div class="col text-center d-none d-md-block">
                    <!-- hodnotenie terminu -->
                    <div class="fw-bold black" *ngIf="skuska.hodnotenieTermin as h">
                        {{ h }}
                        <ng-container *ngIf="getPopis(h) as p">
                            <p *ngIf="p">{{ p }}</p>
                        </ng-container>
                    </div>
                </div>

              <div class="col text-end">

                <div *ngIf="skuska.datumPrihlasenia">

                  <div class="d-flex justify-content-end">
                    <div class="mt-2 mt-lg-0">
                      <button class="width162px" mat-stroked-button [matMenuTriggerFor]="menu" [matTooltip]="'Odhlásiť' | translate">
                        <mat-icon class="icon-green">check_circle</mat-icon>
                        <span class="ms-3 black" i18n>Prihlásený</span>
                      </button>
                    </div>
                  </div>

                  <mat-menu #menu="matMenu">
                    <button class="width162px" mat-flat-button (click)="odhlasit(skuska)" [autofocus]="false">
                      <mat-icon color="accent">cancel</mat-icon><span i18n class="ms-3">Odhlásiť sa</span>
                    </button>
                  </mat-menu>

                </div>

                <div *ngIf="!skuska.datumPrihlasenia" class="d-flex justify-content-end">

                    @if (mozeSaPrihlasit(skuska)) {

                        <div class="mt-2 mt-lg-0">
                            <button class="width162px" mat-stroked-button
                                    [matTooltip]="'Prihlásiť' | translate"
                                    (click)="prihlasit(skuska)">
                                <mat-icon class="icon-blue">add_circle</mat-icon>
                                <span class="ms-3 black" i18n>Prihlásiť</span>
                            </button>
                            <div *ngIf="skuska.odhlasil" class="text-center small text-danger">
                                <span i18n>odhlásil</span>: <span>{{skuska.odhlasil}}</span>
                            </div>
                        </div>

                    } @else {

                        <div class="mt-2 mt-lg-0">
                            <button class="width162px" mat-stroked-button
                                    [disabled]="true"
                                    [matTooltip]="'Prihlásiť' | translate">
                                <mat-icon>block</mat-icon>
                                <span class="ms-3 black" i18n>Prihlásiť</span>
                            </button>
                            <div *ngIf="skuska.odhlasil" class="text-center small text-danger">
                                <span i18n>odhlásil</span>: <span>{{skuska.odhlasil}}</span>
                            </div>
                        </div>

                    }

                </div>


              </div>

              <div class="col-2 col-md-2 text-end">
                <button mat-icon-button (click)="openTerminDetail($event, skuska)" [matTooltip]="'Ďalšie možnosti' | translate">
                  <mat-icon i18n-title title="Detail termínu">more_vert</mat-icon>
                </button>
              </div>

          </div>

          </div>

        </div>

      </div>

    </div>

  </div>

    <div class="text-center" *ngIf="pocetVyhovujucich < 0">
      <h2 class="m-5 p-5 text-center">
        <span i18n>Pre zvolené filtračné podmienky neexistuje žiaden termín skúšky.</span>
      </h2>
    </div>

  </div>

</div>

                </div>
            </div>
        </div>
    </section>
</section>
